module.exports = __webpack_public_path__ + "static/media/wireframe-skeleton.96cf7125.png";